module.exports = __webpack_public_path__ + "static/media/visitbrussels_6.db1c2567.jpg";